import * as ActionTypes from '../actions/actionTypes';

const initialState = { loaded_times: [], loading_index: 0, intervals: [] };

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.ADD_LOADED_TIMES: {
      return { ...state, loaded_times: [...state.loaded_times, ...action.times] };
    }

    case ActionTypes.CLEAR_LOADED_TIMES: {
      return { ...state, loaded_times: [] };
    }

    case ActionTypes.INCREMENT_LOADING_INDEX: {
      return { ...state, loading_index: ++state.loading_index };
    }

    case ActionTypes.RESET_LOADING_INDEX: {
      return { ...state, loading_index: 0 };
    }

    case ActionTypes.SET_INDICATOR_OVERLAY_INTERVALS: {
      return { ...state, intervals: action.intervals };
    }

    case ActionTypes.CLEAR_INDICATOR_OVERLAY_INTERVALS: {
      return { ...state, intervals: [] };
    }

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/indicator_overlays.js